import Box from "@mui/material/Box";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import type { ReactElement } from "react";

import { primitiveColors } from "@dfp/isomorphic-design-tokens";

type Props = Omit<CircularProgressProps, "variant"> & {
  value: number;
  children: ReactElement;
  slots?: {
    BackgroundCircularProgress?: Omit<
      CircularProgressProps,
      "value" | "variant"
    >;
    ForegroundCircularProgress?: Omit<
      CircularProgressProps,
      "value" | "variant"
    >;
  };
};

export function CircularProgressWithLabel({
  slots,
  ...props
}: Props): ReactElement {
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        backgroundColor: primitiveColors.greyscale.white,
        borderRadius: "50%",
        padding: 0.25,
      }}
    >
      <Box display={"flex"} position="relative">
        <CircularProgress
          {...props}
          {...slots?.BackgroundCircularProgress}
          variant="determinate"
          value={100}
        />
        <CircularProgress
          variant="determinate"
          {...props}
          {...slots?.ForegroundCircularProgress}
          sx={{
            ...slots?.ForegroundCircularProgress?.sx,
            position: "absolute",
            left: 0,
          }}
        />
      </Box>
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
}
